import {
  red,
  amber,
  blue,
  grey,
} from "@mui/material/colors";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// 启用 UTC 和时区插件
dayjs.extend(utc);
dayjs.extend(timezone);
// 固定使用北京时间
dayjs.tz.setDefault("Asia/Shanghai");

const muList = ["甲", "乙", "寅", "卯"];
const huoList = ["丙", "丁", "巳", "午"];
const tuList = ["戊", "己", "辰", "戌", "丑", "未"];
const jinList = ["庚", "辛", "申", "酉"];
const shuiList = ["壬", "癸", "子", "亥"];

const tianGanYang = ["甲", "丙", "戊", "庚", "壬"];
const tianGanYin = ["乙", "丁", "己", "辛", "癸"];

const diZhiYang = ["子", "寅", "辰", "午", "申", "戌"];
const diZhiYin = ["丑", "卯", "巳", "未", "酉", "亥"];

function getWuXing(value) {
  if (value) {
    value = value[0];
  }

  let wuxing = "";
  if (muList.includes(value)) {
    wuxing = "木";
  } else if (huoList.includes(value)) {
    wuxing = "火";
  } else if (tuList.includes(value)) {
    wuxing = "土";
  } else if (jinList.includes(value)) {
    wuxing = "金";
  } else if (shuiList.includes(value)) {
    wuxing = "水";
  }
  // console.log(value, wuxing);
  return wuxing;
}

function getWuXingColor(value) {
  let color = "#000000";

  const weight = 700;

  switch (value) {
    case "木":
      color = "#10E536";
      break;
    case "火":
      color = red[weight];
      break;
    case "土":
      color = "#8C6C03";
      break;
    case "金":
      color = amber[weight];
      break;
    case "水":
      color = blue[weight];
      break;
    default:
      break;
  }
  // console.log(value, color);
  return color;
}

function getGanZhiColor(value) {
  const wuxing = getWuXing(value);
  const color = getWuXingColor(wuxing);
  // console.log("**", value, wuxing, color);
  return color;
}

function getIsYang(value) {
  if (tianGanYang.includes(value) || diZhiYang.includes(value)) {
    return true;
  } else if (tianGanYin.includes(value) || diZhiYin.includes(value)) {
    return false;
  }
  return true;
}
function getGrey() {
  return grey[500];
}

function getCellColor(name, value) {
  const dark = getGrey;
  if (name === value) {
    return dark;
  }

  if (name === "日期" || name === "乾造" || name === "坤造") {
    return dark;
  }
  if (name === "空亡") {
    return null;
  }
  return getGanZhiColor(value);
}

function getCellFontWeight(name, value) {
  if (name === value) {
    return "regular";
  }
  if (name === "天干" || name === "地支") {
    return "bold";
  }
}

function getCellVariant(name, value) {
  if (name === value) {
    return "body1";
  }
  if (name === "天干" || name === "地支") {
    return "h5";
  }
  if (name === "大运") {
    return "h5";
  }
  return "body1";
}

function getDirection(name) {
  let direction = "column";
  if (name === "藏干") {
    direction = "row";
  }
  return direction;
}

function utcStr2Show(utc_str) {
  // 将 UTC 时间按北京时间显示
  const dt = dayjs.utc(utc_str).tz("Asia/Shanghai");
  const show = dt.format("YYYY-MM-DD HH:mm");
  return show;
}

function beijingIsoStr2Show(iso_str) {
  // 后端返回的 Date.toISOString() 数值上等于北京时间
  // 因此直接截取显示，不再做时区转换
  if (!iso_str) return "";
  return iso_str.slice(0, 16).replace("T", " ");
}
export {
  getWuXing,
  getWuXingColor,
  getGanZhiColor,
  getIsYang,
  getCellColor,
  getCellFontWeight,
  getCellVariant,
  getDirection,
  getGrey,
  utcStr2Show,
  beijingIsoStr2Show,
};
